import Head from 'next/head'
import { useRouter } from 'next/router'
import getConfig from 'next/config'
import {
  getAlternateUrls,
  getCanonicalUrl,
  getLocaleFromPath,
  getPublicPath,
  LOCALE_OG,
  LOCALES,
} from '@/lib/locales'

export default function HreflangLinks({ path: pathFromProps }) {
  const router = useRouter()
  const {
    publicRuntimeConfig: { host },
  } = getConfig()

  const path = pathFromProps || getPublicPath(router.asPath)
  const locale = getLocaleFromPath(path)
  const canonicalUrl = getCanonicalUrl(path, host)
  const alternates = getAlternateUrls(path, host)

  return (
    <Head>
      <link rel="canonical" href={canonicalUrl} />
      {alternates.map(({ hrefLang, href }) => (
        <link key={hrefLang} rel="alternate" hrefLang={hrefLang} href={href} />
      ))}
      <meta property="og:locale" content={LOCALE_OG[locale]} />
      {LOCALES.filter((code) => code !== locale).map((code) => (
        <meta key={code} property="og:locale:alternate" content={LOCALE_OG[code]} />
      ))}
      <meta property="og:url" content={canonicalUrl} />
    </Head>
  )
}
